import React from 'react';

import { FastshiftRunbookStep } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { useIntl } from 'react-intl';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives';

import { messages } from '../messages';

const renderStepName = (chunks: React.ReactNode) => (
	<Text as="span" weight="bold">
		{chunks}
	</Text>
);

export type RunbookStepCompleteConfirmModalProps = {
	step: FastshiftRunbookStep | null;
	isLoading: boolean;
	onClose: () => void;
	onConfirm: (step: FastshiftRunbookStep) => void;
};

export const RunbookStepCompleteConfirmModal: React.FC<RunbookStepCompleteConfirmModalProps> = ({
	step,
	isLoading,
	onClose,
	onConfirm,
}) => {
	const intl = useIntl();

	return (
		<ModalTransition>
			{step && (
				<Modal onClose={onClose} testId="runbook-step-complete-confirm-modal">
					<ModalHeader>
						<ModalTitle>{intl.formatMessage(messages.runbooksPanelCompleteModalTitle)}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Text>
							{intl.formatMessage(messages.runbooksPanelCompleteModalBody, {
								title: step.title,
								stepName: renderStepName,
							})}
						</Text>
					</ModalBody>
					<ModalFooter>
						<ButtonGroup>
							<Button appearance="subtle" onClick={onClose} isDisabled={isLoading}>
								{intl.formatMessage(messages.runbooksPanelModalCancelButton)}
							</Button>
							<Button
								appearance="primary"
								isLoading={isLoading}
								onClick={() => onConfirm(step)}
								testId="runbook-step-complete-confirm-button"
							>
								{intl.formatMessage(messages.runbooksPanelCompleteModalConfirmButton)}
							</Button>
						</ButtonGroup>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
